import { nanoid } from "nanoid";
import { getUnitFromAlternative } from "./Units";

export const getFirebaseRecordFromRecipe = (recipe) => {
  const id = nanoid();
  
  // Handle instructions - convert to Firebase schema format (array of objects with id, instruction, duration)
  let instructions;
  if (Array.isArray(recipe.i)) {
    instructions = recipe.i.map((instruction) => {
      // Handle both old format (strings) and new format (objects with step/duration)
      if (typeof instruction === 'string') {
        return {
          id: nanoid(),
          instruction: instruction,
          duration: null
        };
      } else if (instruction.step) {
        return {
          id: nanoid(),
          instruction: instruction.step,
          duration: instruction.duration || null
        };
      } else {
        // Fallback for other object formats
        const instructionText = instruction.instruction || instruction.step || String(instruction);
        return {
          id: nanoid(),
          instruction: instructionText,
          duration: instruction.duration || null
        };
      }
    });
  } else if (typeof recipe.i === 'string') {
    instructions = [{
      id: nanoid(),
      instruction: recipe.i,
      duration: null
    }];
  } else {
    instructions = [];
  }
  
  return {
    id,
    name: recipe.n,
    description: recipe.d,
    instructions,
    proteins: parseInt(recipe.mac.p),
    carbs: parseInt(recipe.mac.c),
    fats: parseInt(recipe.mac.f),
    kCals: parseInt(recipe.mac.kCals),
    servings: parseInt(recipe.ns),
    isArchived: false,
    isPublic: false,
    createdOn: new Date(),
    updatedOn: new Date(),
    mealType: recipe.mealType || "other",
  };
};

export const getIngredientsFromRecipe = (recipe) => {
  return recipe.ing.map((ingredient) => {
    const id = nanoid();
    return {
      id,
      name: ingredient.n,
      unit: getUnitFromAlternative(ingredient.u),
      amount: parseInt(ingredient.q),
      proteins: parseInt(ingredient.mac.p),
      carbs: parseInt(ingredient.mac.c),
      fats: parseInt(ingredient.mac.f),
      createdOn: new Date(),
      updatedOn: new Date(),
    };
  });
};
